import { create } from "zustand"

type EntityType = "household" | "contact" | "person" | null

interface TranscriptionContextState {
  entityType: EntityType
  entityId: string | null
  entityKeywords: string[]
  setEntityContext: (type: EntityType, id: string, keywords: string[]) => void
  clearEntityContext: () => void
}

export const useTranscriptionContextStore = create<TranscriptionContextState>((set) => ({
  entityType: null,
  entityId: null,
  entityKeywords: [],
  setEntityContext: (type, id, keywords) =>
    set({
      entityType: type,
      entityId: id,
      entityKeywords: keywords,
    }),
  clearEntityContext: () =>
    set({
      entityType: null,
      entityId: null,
      entityKeywords: [],
    }),
}))
